import React from 'react';
import PropTypes from 'prop-types';

import {Row, Col} from 'reactstrap';

import { CurrentLang, MagstimHistoryFields } from 'common';

class MagstimHistoryDetails extends React.Component {


    getNamedValuePairs(data) {

        let displayData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        if (data.isBurst === false) {
            displayData = [
                { name: CurrentLang().protocol_name, value: data.protocolName },
                { name: CurrentLang().history_details_standard_mode, value: data.mode },
                { name: CurrentLang().history_details_standard_manualLocation, value: data.manualLocation },
                { name: CurrentLang().history_details_standard_stimguideLocation, value: data.stimguideLocation },
                { name: CurrentLang().history_details_standard_pcRMT, value: data.pcRMT },
                { name: CurrentLang().history_details_standard_pps, value: data.pps },
                { name: CurrentLang().history_details_standard_ppt, value: data.ppt },
                { name: CurrentLang().history_details_standard_onTime, value: data.onTime },
                { name: CurrentLang().history_details_standard_offTime, value: data.offTime },
                { name: CurrentLang().history_details_standard_trains, value: data.trains },
                { name: CurrentLang().history_details_standard_pulses, value: data.pulses },
                { name: CurrentLang().history_details_standard_duration, value: data.duration },
                { name: CurrentLang().history_details_standard_accuracy, value: data.accuracy },
                { name: CurrentLang().history_details_standard_additionalPulses, value: data.additionalPulses }
            ];
        }
        else {
            displayData = [
                { name: CurrentLang().protocol_name, value: data.protocolName },
                { name: CurrentLang().history_details_burst_mode, value: data.mode },
                { name: CurrentLang().history_details_burst_manualLocation, value: data.manualLocation },
                { name: CurrentLang().history_details_burst_stimguideLocation, value: data.stimguideLocation },
                { name: CurrentLang().history_details_burst_pcRMT, value: data.pcRMT },
                { name: CurrentLang().history_details_burst_pps, value: data.pps },
                { name: CurrentLang().history_details_burst_ppb, value: data.ppb },
                { name: CurrentLang().history_details_burst_bpc, value: data.bpc },
                { name: CurrentLang().history_details_burst_cycleTime, value: data.cycleTime },
                { name: CurrentLang().history_details_burst_cycles, value: data.cycles },
                { name: CurrentLang().history_details_burst_pulses, value: data.pulses },
                { name: CurrentLang().history_details_burst_duration, value: data.duration },
                { name: CurrentLang().history_details_burst_accuracy, value: data.accuracy },
                { name: CurrentLang().history_details_burst_additionalPulses, value: data.additionalPulses }
            ];
        }

        return displayData;
    }

    render() {

        let allItems = this.getNamedValuePairs(this.props.data);

        var splitPoint = Math.ceil(allItems.length / 2);

        if(splitPoint < allItems.length){
            var leftItems =  allItems.splice(0, splitPoint);
        }
		
        return (
            <Col className="col">
                <Row className="pt-2 pb-2">
                    <Col lg="6" sm="12" className="mt-4">
                        <MagstimHistoryFields listitems={ leftItems } />
                    </Col>
                    <Col lg="6" sm="12" className="mt-4">
                        <MagstimHistoryFields listitems={ allItems } />
                    </Col>
                </Row>
            </Col>
        );
    }
}

MagstimHistoryDetails.propTypes = {
    index: PropTypes.number,
    data: PropTypes.object
};

MagstimHistoryDetails.defaultProps = {
    index: undefined,
    data: undefined
};

export default MagstimHistoryDetails;